"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalFooterMobile = require("./ModalFooterMobile");
Object.keys(_ModalFooterMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalFooterMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalFooterMobile[key];
    }
  });
});